import { buildContentImageSizes } from '~/utils/buildContentImageOptions';

/** Product hero renders its media at 6 of 12 columns. */
const HERO_PRODUCT_IMAGE_COLS = 6;

/** Article hero renders its media at 10 of 12 columns (`make-col(10)` from `lg` upwards). */
const HERO_ARTICLE_IMAGE_COLS = 10;

/**
 * Covers the full range of rendered hero image slots:
 * - 6-column desktop slot: max ~700 px (at 1400 px content width)
 * - Full-width mobile slot: 780 / 870 px cover common 2× DPR phones
 *   (e.g. 375 px × 2 = 750 → 780 w; 430 px × 2 = 860 → 870 w)
 * - Upper range retains 960 / 1200 / 1400 for high-DPR tablets and desktops
 */
export const heroImageWidths = [
  200, 300, 400, 500, 600, 700, 780, 870, 960, 1200, 1400
];

/** The 10-column slot renders up to ~1167 px, so 2× DPR needs candidates beyond 1400. */
export const heroArticleImageWidths = [...heroImageWidths, 1800, 2400];

export const heroImageSizes = buildContentImageSizes(HERO_PRODUCT_IMAGE_COLS);

export const heroArticleImageSizes = buildContentImageSizes(
  HERO_ARTICLE_IMAGE_COLS
);

export const heroImagePreviewWidth = 160;
export const heroImagePreviewQuality = 40;

export const contentMediaPreviewWidth = 160;
export const contentMediaPreviewQuality = 40;

export const heroOverviewImageWidths = [250, 450, 700];
